export default __webpack_public_path__ + "static/media/engagement.01796b67.svg";